import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { db } from "../FirebaseConfig";
import { collection, getDocs, orderBy, query, where } from "firebase/firestore";
import { Card } from "react-bootstrap";
import LoadingSpinner from "../UserProfile/LoadingSpinner";
function BrandsPage2() {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [activeLetter, setActiveLetter] = useState("A");

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const refs = useRef({});
  const letterRef = useRef();
  useEffect(() => {
    const getBrands = async () => {
      try {
        const brandsCollectionRef = collection(db, "brands");
        const brandsQuery = query(
          brandsCollectionRef,
          where("status", ">", 0),
          orderBy("name", "asc")
        );
        const brandsSnapshot = await getDocs(brandsQuery);
        const brandsData = brandsSnapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        setBrands(brandsData);
      } catch (error) {
        console.error("Error fetching brands:", error);
      } finally {
        setLoading(false);
      }
    };

    getBrands();
  }, []);

  // Extract unique first letters from brand names
  const uniqueFirstLetters = Array.from(
    new Set(brands.map((brand) => brand.name[0]))
  ).sort();
  // Generate an array containing all English alphabets
  const allAlphabets = Array.from({ length: 26 }, (_, i) =>
    String.fromCharCode("A".charCodeAt(0) + i)
  );

  const scrollToLetter = (l, id) => {
    setActiveLetter(l);
    const element = refs.current[id];
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
      // letterRef.current.scrollTo({ top: yPosition, behavior: "smooth" });
    }
  };
  const brandRef = useRef();
  // useEffect(() => {
  //   const navbar = document.querySelector(".mobile-navbar-wrapper");

  //   const handleScroll = () => {
  //     if (!navbar.classList.contains("hide-navbar") && window.scrollY > 48) {
  //       brandRef.current.style.transform = "translateY(48px)";
  //     } else {
  //       brandRef.current.style.transform = "translateY(0px)";
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);
  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      {/* <SideNavUserProfile /> */}
      <style jsx>
        {`
          .thinScrollBar::-webkit-scrollbar {
            display: none;
          }
          .thinScrollBar {
            -ms-overflow-style: none; /* IE and Edge */
            scrollbar-width: none; /* Firefox */
          }
          .hover-div:hover {
            background-color: rgb(245, 245, 245);
          }
          [data-bs-theme="dark"] .hover-div:hover {
            background-color: rgb(10, 10, 10);
          }
        `}
      </style>
      {/* <div className="col-md-8 col-lg-6 vstack p-0 mt-0 mt-lg-5 ms-1 "> */}
      <div
        className="d-flex flex-column w-100"
        style={{ padding: isSmallScreen ? "0px" : "20px 0px 0px" }}
      >
        <div
          className={`d-flex flex-column w-100 bg-white ${isSmallScreen ? "stickyHeaderMobile" : "stickyHeader"
            }`}
          ref={brandRef}
        >
          <div style={{ padding: isSmallScreen ? "12px 6px" : "4px 6px" }}>
            <div
              style={{
                fontFamily: "Inter",
                fontWeight: "500",
                fontSize: isSmallScreen ? "18px" : "20px",
                letterSpacing: "0%",
                color: "#000000",
              }}
            >
              Discover all Brands
            </div>
          </div>
          <div style={{ padding: isSmallScreen ? "4px 6px" : "10px 6px" }}>
            <div
              className="d-flex flex-row thinScrollBar"
              style={{ overflowX: "auto", gap: "8px" }}
            >
              {allAlphabets.map((l, index) => (
                <div
                  style={{
                    backgroundColor: !uniqueFirstLetters.includes(l)
                      ? "#F4F4F4"
                      : activeLetter === l
                        ? "#005FDA"
                        : "#F4F9FF",
                    borderRadius: "8px",
                    cursor: uniqueFirstLetters.includes(l)
                      ? "pointer"
                      : "default",
                  }}
                  key={l}
                  className={`${uniqueFirstLetters.includes(l) ? "border-0" : ""
                    } text-uppercase `}
                  onClick={() => {
                    if (uniqueFirstLetters.includes(l))
                      scrollToLetter(l, index);
                  }}
                >
                  <div
                    className="d-flex justify-content-center align-items-center "
                    style={{
                      height: "32px",
                      width: "32px",
                      color: !uniqueFirstLetters.includes(l)
                        ? "#676A79"
                        : activeLetter === l
                          ? "#FFFFFF"
                          : "#005FDA",
                      fontFamily: "Inter",
                      fontWeight: "500",
                      fontSize: "14px",
                      letterSpacing: "0%",
                    }}
                  >
                    {l}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="p-0 thinScrollBar bg-mode" ref={letterRef}>
          {allAlphabets.map((letter, index) =>
            uniqueFirstLetters.includes(letter) ? (
              <div
                key={letter}
                id={letter}
                ref={(el) => (refs.current[index] = el)} // Store refs by item ID
                className="hover-div"
              >
                <div
                  className="d-flex flex-column"
                  style={{
                    padding: isSmallScreen ? "8px 10px" : "12px 10px",
                    gap: "8px",
                  }}
                >
                  <div
                    style={{
                      fontFamily: "Inter",
                      fontWeight: "400",
                      fontSize: isSmallScreen ? "16px" : "20px",
                      lineHeight: "100%",
                      letterSpacing: "0%",
                      color: "#000000",
                    }}
                  >
                    {letter}
                  </div>
                  <div style={{ border: "1px solid #EDEDED" }} />

                  <div
                    className="d-flex flex-row hiddenScrollbar"
                    style={{
                      overflowX: "auto",
                      overflowY: "hidden",
                      whiteSpace: "nowrap",
                      width: "100%",
                      gap: isSmallScreen ? "10px" : "14px",
                    }}
                  >
                    {brands
                      .filter((brand) => brand.name[0] === letter)
                      .map((brand) => (
                        <Link
                          to={`/BrandHome/${brand.name}`}
                          className="d-flex flex-column align-items-center text-center"
                          style={{
                            width: isSmallScreen ? "64px" : "90px",
                            minWidth: isSmallScreen ? "64px" : "90px",
                            textDecoration: "none",
                            gap: "8px",
                          }}
                        >
                          <img
                            src={brand?.logoUrl}
                            style={{
                              width: isSmallScreen ? "42px" : "60px",
                              maxWidth: isSmallScreen ? "42px" : "60px",
                              height: isSmallScreen ? "42px" : "60px",
                              borderRadius: "6px",
                              // objectFit: "cover",
                            }}
                            className="border"
                            alt=""
                            loading="lazy"
                          />
                          <div
                            className="text-wrap"
                            style={{
                              display: "-webkit-box",
                              "-webkit-line-clamp": "2",
                              "-webkit-box-orient": "vertical",
                              fontFamily: "Inter",
                              wordWrap: "break-word",
                              fontWeight: "500",
                              fontSize: isSmallScreen ? "12px" : "14px",
                              letterSpacing: "0%",
                              color: "#000000",
                            }}
                          >
                            {brand?.displayName}
                          </div>
                        </Link>
                      ))}
                  </div>
                </div>
              </div>
            ) : (
              <div
                key={letter}
                id={letter}
                ref={(el) => (refs.current[index] = el)} // Store refs by item ID
              ></div>
            )
          )}
        </div>
      </div>
    </>
  );
}

export default BrandsPage2;
